import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useSegmentPage } from "@/hooks/use-segment";

// Global state to track previous page for referrer
let previousPageUrl: string | null = null;

export const PageCategories = {
    OnaOnboarding: "Ona Onboarding",
} as const;

export type PageCategory = (typeof PageCategories)[keyof typeof PageCategories];

/**
 * Hook to track page views using Segment's page() method
 * @param pageName - The name of the page to track
 * @param category - Optional category for the page (e.g., "Onboarding")
 * @param properties - Additional properties to include with the page event
 */
export const usePageTracking = (pageName: string, category?: PageCategory, properties?: Record<string, unknown>) => {
    const segmentPage = useSegmentPage();
    const location = useLocation();
    const currentPageKey = useRef<string>("");

    useEffect(() => {
        const currentUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
        const pageKey = `${category || ""}:${pageName}`;

        // Only track if this is a new page (different from last tracked page)
        if (currentPageKey.current !== pageKey) {
            currentPageKey.current = pageKey;

            const referrer = previousPageUrl || document.referrer || undefined;
            segmentPage(pageName, category, properties, referrer);

            previousPageUrl = currentUrl;
        }
    }, [segmentPage, pageName, category, properties, location.pathname, location.search, location.hash]);
};
